import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/site';
import { SectionCta } from './SectionCta';
export function Testimonials() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-304" data-mp="3fze27tb8kvtk">
      <div className="mx-auto max-w-4xl" data-id="element-305" data-mp="3fxksu698nxhv">
        <div className="text-center" data-id="element-306" data-mp="3b143x9u7tf3q">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-307" data-mp="3b01e758mpipe">From the consultation room</p>
          <h2 className="mt-3 font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-308" data-mp="36wwh5i7bi985">
            What healthcare professionals say
          </h2>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-309" data-mp="2x1bjfw9a7v47">
          {testimonials.map((item, i) => <figure key={item.name} className={`flex h-full flex-col rounded-2xl border border-navy/10 bg-white p-5 sm:p-6 ${i === 0 ? 'sm:col-span-2' : ''}`} data-id="element-310" data-mp="2s39q8ii56ff0" data-mpi={i}>
              <div className="flex items-center gap-1" aria-label="Rated 5 out of 5" data-id="element-311" data-mp="h5y7ibcyv721">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-312" data-mp="m5sz6h4kg0o5" data-mpi={star} />)}
              </div>
              <QuoteIcon className="mt-3 h-5 w-5 text-gold/40" aria-hidden="true" data-id="element-313" data-mp="7a4z946a5zq2" />
              <blockquote className={`mt-2 flex-1 leading-relaxed text-navy/80 ${i === 0 ? 'font-serif text-[18px] italic sm:text-[21px]' : 'text-[14.5px]'}`} data-id="element-314" data-mp="c8y0ny8am09v">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-315" data-mp="q63dqi6fbzem">
                <img src={item.image} alt={item.name} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} data-id="element-316" data-mp="v44wf1zxtwpk" />
                <div className="min-w-0" data-id="element-317" data-mp="1xi0lr5tr9nwj">
                  <p className="text-[14px] font-bold leading-tight text-navy" data-id="element-318" data-mp="1xgpkpdrp2u94">{item.name}</p>
                  <p className="mt-0.5 text-[12.5px] leading-tight text-navy/60" data-id="element-319" data-mp="1sjz7qzb6serx">{item.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta headline="Join the professionals already working from a structured desk." label="Get my access for $27" data-id="element-320" data-mp="1jj0xhza5nb0w" />
      </div>
    </section>;
}